<template>
	<div v-if="!item.hidden" class="my-menu">
		<!-- 侧边栏菜单区 -->
		<template
			v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
			<el-menu-item :index="resolvePath(onlyOneChild.path)" class="text-align-left">
				<i :class="onlyOneChild.meta.icon"></i>
				<span slot="title">{{onlyOneChild.meta.title}}</span>
			</el-menu-item>
		</template>
		<!-- index 值需要字符串-->
		<el-submenu :index="resolvePath(item.path)" v-else>
			<template slot="title">
				<i :class="item.meta.icon"></i>
				<span slot="title">{{item.meta.title}}</span>
			</template>
			<div v-for="(subItem,index) in item.children" :key='index'>
				<el-submenu :index="resolvePath(subItem.path)" v-if="subItem.children!=undefined">
					<template slot="title">
						<i :class="subItem.meta.icon"></i>
						<span slot="title">{{subItem.meta.title}}</span>
					</template>
					<el-menu-item :index="resolvePath1(subItem.path,subItem1.path)"
						v-for="(subItem1,index1) in subItem.children" :key='index1'>
						<i :class="subItem1.meta.icon"></i>
						<span slot="title">{{subItem1.meta.title}}</span>
					</el-menu-item>
				</el-submenu>
				<el-menu-item :index="resolvePath(subItem.path)" v-else>
					<i :class="subItem.meta.icon"></i>
					<span slot="title">{{subItem.meta.title}}</span>
				</el-menu-item>
			</div>
		</el-submenu>
	</div>
</template>

<script>
	import path from 'path'
	export default {
		props: {
			item: {
				type: Object,
				required: true
			},
			basePath: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				onlyOneChild: null
			};
		},
		methods: {
			hasOneShowingChild(children = [], parent) {
				const showingChildren = children.filter(item => {
					if (item.hidden) {
						return false
					} else {
						// Temp set(will be used if only has one showing child)
						this.onlyOneChild = item
						return true
					}
				})
				//当只有一个子路由器时，默认情况下显示子路由器
				if (showingChildren.length === 1) {
					return true
				}
				// Show parent if there are no child router to display
				if (showingChildren.length === 0) {
					this.onlyOneChild = {
						...parent,
						path: '',
						noShowingChildren: true
					}
					return true
				}
				return false
			},
			resolvePath(routePath) {
				//this.$router 当前激活的路由信息对象 拼接 父路径
				return path.resolve(this.basePath, routePath)
			},
			//三级菜单
			resolvePath1(basePath, routePath) {
				return path.resolve(this.basePath + "/" + basePath, routePath)
			}
		}
	}
</script>
<style lang="scss" scoped>
	.el-menu {
		border: none;
	}

	.el-submenu .is-active {
		color: #fff;
		background-color: #1989fa !important;

	}

	.el-submenu /deep/ .el-submenu__title {
		height: 44px;
		line-height: 44px;

	}


	.text-align-left {
		text-align: left;
	}

	/*隐藏文字*/
	.el-menu--collapse .el-submenu__title span {
		display: none;
	}


	.my-menu .el-menu-item {
		height: 44px;
		line-height: 44px;
		padding: 0 45px;
		min-width: 200px;
	}


	/*隐藏  >图标 */
	.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
		display: none;
	}
</style>
